// extracted by mini-css-extract-plugin
export var legendIndicator = "_ej-1";
export var legendRight = "_ej-0";